import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserContext } from '../context/UserContext';
import { useContext } from 'react';
import { logger } from '../services/LoggerService';
import { useDataStoreService } from '../context/DataStoreContext';
import { AppRoutes } from '../routes';

export const useVerifyEmail = () => {
    const navigate = useNavigate();
    const authService = useAuth();
    const [disabledSubmit, setDisableSubmit] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const user = authService.getCurrentUser();
    const userEmail = user?.email;
    const { setUserProfile } = useContext(UserContext);
    const { tutorProfileService } = useDataStoreService();

    useEffect(() => {
        if (user?.emailVerified) {
            navigate(AppRoutes.TUTOR_PROFILE);
        }
    }, [user?.emailVerified, navigate]); // Only depend on emailVerified, not the entire user object

    // TODO: design custom verification email template
    const handleResendVerificationEmail = async () => {
        try {
            setDisableSubmit(true);
            // TODO: Prevent multiple attempts, and flag (needs research)
            await authService.sendEmailVerification();
            await authService.logout();
            logger.info('Verification email sent successfully.');
        } catch (error: any) {
            setError(error.message);
        }
    };

    const handleBackAction = async () => {
        // TODO: prevent extra API calls to logout, research better way
        await authService.logout();
        navigate(AppRoutes.LOGIN);
    };

    const handleDeleteAccount = async () => {
        if (window.confirm('Are you sure you want to delete your account?')) {
            try {
                await tutorProfileService.deleteUserProfile(user?.uid!);
                await authService.deleteUser();
                setUserProfile(null);
                navigate(AppRoutes.LOGIN);
            } catch (err: any) {
                setError(err.message);
            }
        }
    };

    return {
        disabledSubmit,
        error,
        userEmail,
        handleResendVerificationEmail,
        handleBackAction,
        handleDeleteAccount,
    };
};
